/**
 * 「你的可见范围被限定在这几个通道」的说明条。
 *
 * ## 为什么需要它
 *
 * 被收窄之后，界面看起来是**完全正常的，只是比较短**：通道列表少几行、
 * 交易少几笔、侧栏少一个「资金」分组。它跟一个真的只有两个通道、
 * 交易本来就不多的平台长得一模一样。
 *
 * 于是用的人会把「少」理解成「就这么多」，而不是「你只被允许看这些」。
 * 这两件事对通道运营的判断影响完全不同 —— 前者他会以为自己看到了全貌，
 * 拿这个数去汇报；后者他知道要去问别人拿另一半。
 *
 * 所以这条说明不是装饰，它是让屏幕上的数字可被正确解读的前提。
 *
 * 不受约束的成员这里返回 null，一个像素都不占。
 */

import { useSession } from '../lib/session.tsx';

export function ScopeBanner({ context }: { context?: string | undefined }) {
  const { isChannelScoped, scopedChannels } = useSession();
  if (!isChannelScoped) return null;

  return (
    <div className="mb-3 rounded-md border border-warn/30 bg-warn-soft px-3 py-2 text-[12.5px] leading-relaxed text-ink">
      <span className="font-semibold">可见范围已限定</span>
      <span className="text-ink-muted">
        {'：你的账号只能看到 '}
      </span>
      {scopedChannels.map((channel, index) => (
        <span key={channel.id}>
          {index > 0 ? <span className="text-ink-muted">、</span> : null}
          <span className="font-semibold">{channel.label}</span>
          <span className="text-ink-faint">{` (${channel.channel_code})`}</span>
        </span>
      ))}
      <span className="text-ink-muted">
        {context === undefined ? ' 这些通道的数据。' : `${' '}${context}`}
      </span>
    </div>
  );
}
